import { Factory } from "../../core/factory";

export const registerMarkMapTransform = () => {
    Factory.registerGrammarTransform("map", {
        transform: (options, data) => (null == data || data.forEach(((datum, index) => {
            options.callback(datum);
        })), data)
    });
};
//# sourceMappingURL=map.js.map
